<div [ngClass]="iconClasses" class="cursor-pointer"
     (click)="onClick()"
     (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()"></div>
<div *ngIf="description" class="mt-2 text-xs tk-c-gray">{{description}}</div>
